import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "113",
  height: "112",
  viewBox: "0 0 113 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_2389_726)\"><path d=\"M112.667 0H0.666504V112H112.667V0Z\" fill=\"#F6EFFD\"></path><path d=\"M84.6664 37.3333H47.3331C42.1784 37.3333 37.9998 41.512 37.9998 46.6666V84C37.9998 89.1546 42.1784 93.3333 47.3331 93.3333H84.6664C89.8211 93.3333 93.9998 89.1546 93.9998 84V46.6666C93.9998 41.512 89.8211 37.3333 84.6664 37.3333Z\" fill=\"#D9BFF8\"></path><path d=\"M65.9999 18.6667H28.6666C23.5119 18.6667 19.3333 22.8454 19.3333 28V65.3334C19.3333 70.488 23.5119 74.6667 28.6666 74.6667H65.9999C71.1546 74.6667 75.3333 70.488 75.3333 65.3334V28C75.3333 22.8454 71.1546 18.6667 65.9999 18.6667Z\" fill=\"#B47FF2\"></path></g><defs><clipPath id=\"clip0_2389_726\"><rect width=\"112\" height=\"112\" fill=\"white\" transform=\"translate(0.666504)\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }